export enum ReportType {
    SUBJECTQUESTIONANALYSIS = 'Subject Question Analysis',
    ACTUALVSPREDICTED ='Actual Vs Predicted',
    INTERNALASSESMENTANALYSIS = 'Internal Assesment Analysis'
}